import { createPortal } from "react-dom";

import "suneditor/dist/css/suneditor.min.css"; // Import Sun Editor's CSS File

import AddArticleModalData from "./AddArticleModal";

import { useContext, useState, useEffect } from "react";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import sendRequest from "hooks/useAxios";
import toast from "react-hot-toast";
import { NavLink } from "react-router-dom";
function BlogVideo({ postList }) {
  const [updater, setUpdater] = useState(false);

  const auth = useContext(WithAuthentication);
  const options = postList.map(value => {
    return <option value={value.id}>{value.title}</option>;
  });
  const [sectionValue, setSectionValue] = useState([
    { id: "", file: "" },
    { id: "", file: "" },
    { id: "", file: "" }
  ]);
  const [images, setImages] = useState([[], [], []]);
  const changeHandler = (e, index, type) => {
    if (type == 0) {
      setSectionValue(prev => {
        let temp = [...prev];
        temp[index].file = e.target.files[0];
        return temp;
      });
    } else if (type == 1) {
      setSectionValue(prev => {
        let temp = [...prev];
        temp[index].id = e.target.value;
        return temp;
      });
    }
  };
  const updateSection = () => {
    let fd = new FormData();
    fd.append(
      "ids",
      sectionValue
        .map(value => {
          return value.id;
        })
        .join()
    );
    for (let i = 0; i < sectionValue.length; i++) {
      fd.append(`file${i}`, sectionValue[i].file);
    }
    sendRequest("updateblogconfig", fd).then(({ data }) => {
      if (data.status == 1) {
        toast.success("با موفقیت ویرایش شد.");
        document.querySelector("#edit-blog-section-modal .btn-close").click();

        setUpdater(prev => {
          return !prev;
        });
      } else {
        toast.error("مشکلی در ویرایش پیش آمده است.");
      }
    });
  };
  useEffect(() => {
    sendRequest("Find_boxs_configs", { conditions: "pagecode/=/7" }).then(
      ({ data }) => {
        let temp = data[0].custom_config.split(",");
        setSectionValue([
          { id: temp[0], file: "" },
          { id: temp[2], file: "" },
          { id: temp[4], file: "" }
        ]);
        setImages([[temp[1], temp[0]], [temp[3], temp[2]], [temp[5], temp[4]]]);
      }
    );
  }, [updater]);
  // مدال ویرایش
  const modal1 = (
    <div
      className="modal fade"
      id="edit-blog-section-modal"
      tabIndex={-1}
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <div>
              <h5>سکشن اول: </h5>
              <div className="d-flex ">
                <label for="file-1" className="mx-3">
                  فایل
                </label>
                <input
                  type="file"
                  className="form-control ms-2"
                  onChange={e => {
                    changeHandler(e, 0, 0);
                  }}
                />
              </div>
              <div className="d-flex mt-2">
                <label for="select-1" className="mx-3">
                  مطلب
                </label>
                <select
                  className=""
                  className="form-control form-select"
                  onChange={e => {
                    changeHandler(e, 0, 1);
                  }}
                >
                  {options}
                </select>
              </div>
            </div>

            <div className="mt-3">
              <h5>سکشن دوم: </h5>
              <div className="d-flex ">
                <label for="file-1" className="mx-3">
                  فایل
                </label>
                <input
                  type="file"
                  className="form-control ms-2"
                  onChange={e => {
                    changeHandler(e, 1, 0);
                  }}
                />
              </div>
              <div className="d-flex mt-2">
                <label for="select-1" className="mx-3">
                  مطلب
                </label>
                <select
                  className=""
                  className="form-control form-select"
                  onChange={e => {
                    changeHandler(e, 1, 1);
                  }}
                >
                  {options}
                </select>
              </div>
            </div>
            <div className="mt-3">
              <h5>سکشن سوم: </h5>
              <div className="d-flex ">
                <label for="file-1" className="mx-3">
                  فایل
                </label>
                <input
                  type="file"
                  className="form-control ms-2"
                  onChange={e => {
                    changeHandler(e, 2, 0);
                  }}
                />
              </div>
              <div className="d-flex mt-2">
                <label for="select-1" className="mx-3">
                  مطلب
                </label>
                <select
                  className=""
                  className="form-control form-select"
                  onChange={e => {
                    changeHandler(e, 2, 1);
                  }}
                >
                  {options}
                </select>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              بستن
            </button>
            <button
              type="button"
              className="btn btn-success"
              onClick={updateSection}
            >
              ذخیره
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      {auth.userInfo.userType == 0 && (
        <>
          {" "}
          <div className="mx-5 mt-2 d-flex admin-buttons-blog">
            <button
              className="btn btn-primary"
              data-bs-toggle="modal"
              data-bs-target="#edit-blog-section-modal"
            >
              ویرایش
            </button>
            {createPortal(modal1, document.getElementById("modals"))}
            {/* <button
              className="btn btn-success p-2 mx-2"
              data-bs-toggle="modal"
              data-bs-target="#addArticleModal"
            >
              افزودن مطلب
            </button> */}
          </div>
          {/* <AddArticleModalData></AddArticleModalData> */}
        </>
      )}

      <div className="row mx-0 mt-3 first-blog-section-container">
        <div className="col-lg-5 col-md-5 mt-2 text-center">
          <NavLink to={`/article/${images[0][1]}`}>
            <div className="pointer">
              <img
                src={"http://grc.tatdemo.ir/" + images[0][0]}
                style={{
                  width: "95%",
                  borderRadius: "10px",
                  maxHeight: "210px",
                  marginBottom: "10px"
                }}
              />
            </div>
          </NavLink>
          <NavLink to={`/article/${images[1][1]}`}>
            <div className="pointer">
              <img
                src={"http://grc.tatdemo.ir/" + images[1][0]}
                style={{
                  width: "95%",
                  maxHeight: "210px",
                  borderRadius: "10px"
                  // marginBottom: "10px"
                }}
              />
            </div>
          </NavLink>
        </div>
        <NavLink
          to={`/article/${images[2][1]}`}
          className="col-lg-7 col-md-7 mt-2 text-center pointer"
        >
          <div className="h-100">
            <img
              src={"http://grc.tatdemo.ir/" + images[2][0]}
              style={{
                width: "95%",
                maxHeight: "440px",
                borderRadius: "10px",
                marginBottom: "10px"
              }}
              className="pic-3 h-100"
            />
          </div>
        </NavLink>
      </div>
    </div>
  );
}
export default BlogVideo;
